import React from "react"
import { classNames } from "utils/classNames"

export default ({
  title,
  icon: Icon,
  badge,
  onClick,
  iconSize,
  isActive,
  disabled,
  name,
}) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <button
        disabled={disabled}
        onClick={onClick}
        className="relative text-[#323232] hover:text-[color:var(--custom-primary)] disabled:cursor-not-allowed"
      >
        <Icon
          size={iconSize}
          className={classNames(
            isActive
              ? name === "seens"
                ? "stroke-[color:var(--custom-primary)] stroke-2"
                : "fill-[color:var(--custom-primary)] stroke-[color:var(--custom-primary)]"
              : "",
            "stroke-1"
          )}
        />
        {badge ? (
          <>
            <span className="text-xs absolute -top-3 -right-3 px-2 py-0.5 rounded-full bg-[color:var(--custom-primary)] text-white">
              {badge}
            </span>
          </>
        ) : null}
      </button>
      {title ? (
        <span className="text-base font-medium text-black">{title}</span>
      ) : null}
    </div>
  )
}
